import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
import Dropdown from "../../../Components/Shared/Dropdown/Dropdown";
import InterogativeImg from "../../../Assets/Images/CommanImages/Informative.png";
import ErrorIcon from "../../../Assets/Images/CommanImages/Error.png";
import WarningIcon from "../../../Assets/Images/CommanImages/Warning.png";
import { fetchRoleData } from "../../../Redux/features/CreateRole/createRoleSlice";
import TableWithCrossStudentGroup from "../../StudentGrouph/TableWithCrossStudentGroup";
import TableWithCrossSelections from "./TableWithCrossSelections";
import DropdownWithPagination from "../../StudentGrouph/DropdownWithPagination";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import "./updatecreaterole.css";

function NewCreateRole({
  dataClient,
  setMessageBox,
  messageBox,
  setIsMessageBoxVisible,
  setActiveImg,
}) {
  const navigate = useNavigate();
  const isUpdatingFromScreenTable = useRef(false);
  const isUpdatingFromReportTable = useRef(false);

  const [isOpenShareBranch, setIsOpenShareBranch] = useState(true);
  const [roleName, setRoleName] = useState("");
  const [roleCode, setRoleCode] = useState("");
  const [status, setStatus] = useState(null);
  const [description, setDescription] = useState("");

  // Screen states
  const [selectedScreens, setSelectedScreens] = useState([]);
  const [screenOptions, setScreenOptions] = useState([]);
  const [allSelectedScreensData, setAllSelectedScreensData] = useState([]); // NEW: Store all selected screens data
  const [permissions, setPermissions] = useState({});
  const [expandedScreens, setExpandedScreens] = useState({});

  // Reports section states
  const [isOpenReports, setIsOpenReports] = useState(true);
  const [selectedReports, setSelectedReports] = useState([]);
  const [reportOptions, setReportOptions] = useState([]);
  const [allSelectedReportsData, setAllSelectedReportsData] = useState([]); // NEW: Store all selected reports data
  const [reportPermissions, setReportPermissions] = useState({});

  const [isOpenDetails, setIsOpenDetails] = useState(true);
  const { data, loading, error } = useSelector((state) => state.createRole);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchRoleData());
  }, [dispatch]);

  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name;
  const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id;
  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
  const accessToken = localStorage.getItem("other");

  // Fetch screens based on search key
  const fetchScreens = async (searchKey) => {
    if (!searchKey || searchKey.trim().length < 2) {
      setScreenOptions([]);
      return;
    }

    try {
      const filtered = data.filter((item) =>
        item.screen_name.toLowerCase().includes(searchKey.toLowerCase())
      );

      const formattedOptions = filtered.map((screen) => ({
        id: screen.screen_id,
        label: screen.screen_name,
        fullData: screen,
      }));

      setScreenOptions(formattedOptions);
    } catch (error) {
      console.error("Error fetching screens:", error);
      setScreenOptions([]);
    }
  };

  // Fetch reports based on search key
  const fetchReports = async (searchKey) => {
    if (!searchKey || searchKey.trim().length < 2) {
      setReportOptions([]);
      return;
    }

    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-report-list-by-search-key?search_key=${searchKey}`,
        {
          method: "GET",
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const result = await response.json();

      if (result.status === 200 && result.data) {
        const formattedOptions = result.data.map((report) => ({
          id: report.report_id,
          label: report.display_name,
          fullData: report,
        }));
        setReportOptions(formattedOptions);
      } else {
        setReportOptions([]);
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
      setReportOptions([]);
    }
  };

  // // NEW: Update selected screens and store their data
  // useEffect(() => {
  //   if (!isUpdatingFromScreenTable.current) {
  //     // When dropdown selection changes, update stored data
  //     const newlySelectedScreens = screenOptions.filter(opt =>
  //       selectedScreens.includes(opt.id)
  //     );

  //     setAllSelectedScreensData(prev => {
  //       const existingIds = new Set(prev.map(s => s.id));
  //       const toAdd = newlySelectedScreens.filter(s => !existingIds.has(s.id));
  //       return [...prev, ...toAdd];
  //     });
  //   }
  // }, [selectedScreens, screenOptions]);

  // useEffect(() => {
  //   if (!isUpdatingFromScreenTable.current) {
  //     const newlySelectedScreens = screenOptions.filter(opt =>
  //       selectedScreens.includes(opt.id)
  //     );

  //     setAllSelectedScreensData(prev => {
  //       const existingIds = new Set(prev.map(s => s.id));
  //       const toAdd = newlySelectedScreens.filter(s => !existingIds.has(s.id));

  //       // Auto-select READ permission for newly added screens
  //       if (toAdd.length > 0) {
  //         setPermissions(prevPerms => {
  //           const updatedPerms = { ...prevPerms };
  //           toAdd.forEach(screen => {
  //             if (!updatedPerms[screen.id]) {
  //               updatedPerms[screen.id] = { read: true };
  //             }
  //           });
  //           return updatedPerms;
  //         });
  //       }

  //       return [...prev, ...toAdd];
  //     });
  //   }
  // }, [selectedScreens, screenOptions]);

  useEffect(() => {
    if (!isUpdatingFromScreenTable.current) {
      const newlySelectedScreens = screenOptions.filter((opt) =>
        selectedScreens.includes(opt.id)
      );

      setAllSelectedScreensData((prev) => {
        const existingIds = new Set(prev.map((s) => s.id));
        const toAdd = newlySelectedScreens.filter(
          (s) => !existingIds.has(s.id)
        );

        // Auto-select READ permission for newly added screens
        if (toAdd.length > 0) {
          setPermissions((prevPerms) => {
            const updatedPerms = { ...prevPerms };
            toAdd.forEach((screen) => {
              if (!updatedPerms[screen.id]) {
                updatedPerms[screen.id] = { read: true };
              }
            });
            return updatedPerms;
          });
        }

        return [...prev, ...toAdd];
      });
    }
  }, [selectedScreens, screenOptions]);

  // NEW: Update selected reports and store their data
  useEffect(() => {
    if (!isUpdatingFromReportTable.current) {
      // When dropdown selection changes, update stored data
      const newlySelectedReports = reportOptions.filter((opt) =>
        selectedReports.includes(opt.id)
      );

      setAllSelectedReportsData((prev) => {
        const existingIds = new Set(prev.map((r) => r.id));
        const toAdd = newlySelectedReports.filter(
          (r) => !existingIds.has(r.id)
        );
        return [...prev, ...toAdd];
      });
    }
  }, [selectedReports, reportOptions]);

  const toggleAccordionShareBranch = () =>
    setIsOpenShareBranch((prev) => !prev);

  const toggleExpand = (screenId) => {
    setExpandedScreens((prev) => ({
      ...prev,
      [screenId]: !prev[screenId],
    }));
  };

  // Screen table headers
  const headers = [
    "Screen ID",
    "Screen Name",
    "Edit",
    "Create",
    "Read",
    "Delete",
    "Print & Download",
    // "Download",
  ];

  // Build screen table data - NOW USES allSelectedScreensData instead of screenOptions
  const tableData = (Array.isArray(selectedScreens) ? selectedScreens : [])
    .map((screenId) => {
      const opt = allSelectedScreensData.find((o) => o.id === screenId);
      if (!opt || !opt.fullData) return null;

      const screen = opt.fullData;
      const perms = permissions[screen.screen_id] || {};
      const isExpanded = expandedScreens[screen.screen_id];
      const sectionList = screen.sections || [];
      const hasSections = sectionList.length > 0;

      return [
        screenId,
        screen.screen_name,
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            {hasSections && (
              <>
                <input
                  type="checkbox"
                  className="cr-custom-checkbox"
                  checked={perms.allSections || false}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    handlePermissionChange(
                      screen.screen_id,
                      null,
                      "allSections",
                      checked
                    );
                  }}
                />

                <span
                  onClick={() => toggleExpand(screen.screen_id)}
                  style={{
                    cursor: "pointer",
                    fontWeight: "bold",
                    marginLeft: "8px",
                    userSelect: "none",
                  }}
                >
                  {isExpanded ? "−" : "+"}
                </span>

                <span style={{ marginLeft: "8px", marginRight: "20px" }}>
                  All Sections
                </span>
              </>
            )}

            {!hasSections && (
              <input
                type="checkbox"
                className="cr-custom-checkbox"
                checked={perms.edit || false}
                onChange={(e) =>
                  handlePermissionChange(
                    screen.screen_id,
                    null,
                    "edit",
                    e.target.checked
                  )
                }
              />
            )}
          </div>

          {hasSections && isExpanded && (
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                marginLeft: "24px",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              {sectionList.map((section) => {
                const secPerm = perms.sections?.[section.sec_id]?.edit || false;
                return (
                  <label
                    key={section.sec_id}
                    style={{ display: "flex", gap: "6px" }}
                  >
                    <input
                      type="checkbox"
                      className="cr-custom-checkbox"
                      checked={secPerm}
                      onChange={(e) => {
                        handlePermissionChange(
                          screen.screen_id,
                          section.sec_id,
                          "edit",
                          e.target.checked
                        );
                      }}
                    />
                    {section.sec_name}
                  </label>
                );
              })}
            </div>
          )}
        </div>,

        // Create
        <input
          type="checkbox"
          className="cr-custom-checkbox"
          checked={perms.create || false}
          onChange={(e) =>
            handlePermissionChange(
              screen.screen_id,
              null,
              "create",
              e.target.checked
            )
          }
        />,

        // Read
        <input
          type="checkbox"
          className="cr-custom-checkbox"
          // checked={perms.read || false}
          checked={true}
          disabled={true}
          onChange={(e) =>
            handlePermissionChange(
              screen.screen_id,
              null,
              "read",
              e.target.checked
            )
          }
        />,

        // Delete
        <input
          type="checkbox"
          className="cr-custom-checkbox"
          checked={perms.delete || false}
          onChange={(e) =>
            handlePermissionChange(
              screen.screen_id,
              null,
              "delete",
              e.target.checked
            )
          }
        />,

        // Print
        <input
          type="checkbox"
          className="cr-custom-checkbox"
          checked={perms.print || false}
          onChange={(e) =>
            handlePermissionChange(
              screen.screen_id,
              null,
              "print",
              e.target.checked
            )
          }
        />,

        // Download
        // <input
        //   type="checkbox"
        //   className="cr-custom-checkbox"
        //   checked={perms.download || false}
        //   onChange={(e) =>
        //     handlePermissionChange(screen.screen_id, null, "download", e.target.checked)
        //   }
        // />,
      ];
    })
    .filter(Boolean);

  // Handle permission changes
  const handlePermissionChange = (screenId, secId, permissionType, checked) => {
    setPermissions((prev) => {
      const currentScreenPerms = prev[screenId] || {};
      const currentSections = currentScreenPerms.sections || {};
      const updatedSections = { ...currentSections };
      const screen = allSelectedScreensData.find(
        (o) => o.fullData?.screen_id === screenId
      )?.fullData;
      const sectionList = screen?.sections || [];

      // Handle "All Sections" checkbox
      if (permissionType === "allSections") {
        const newSections = {};
        sectionList.forEach((sec) => {
          newSections[sec.sec_id] = {
            ...(updatedSections[sec.sec_id] || {}),
            edit: checked,
          };
        });

        return {
          ...prev,
          [screenId]: {
            ...currentScreenPerms,
            allSections: checked,
            edit: checked,
            sections: newSections,
          },
        };
      }

      // Handle individual section checkbox
      if (secId) {
        updatedSections[secId] = {
          ...(updatedSections[secId] || {}),
          edit: checked,
        };

        const allChecked = sectionList.every(
          (sec) => updatedSections[sec.sec_id]?.edit
        );
        const allUnchecked = sectionList.every(
          (sec) => !updatedSections[sec.sec_id]?.edit
        );
        const anyChecked = sectionList.some(
          (sec) => updatedSections[sec.sec_id]?.edit
        );

        return {
          ...prev,
          [screenId]: {
            ...currentScreenPerms,
            allSections: allChecked
              ? true
              : allUnchecked
              ? false
              : currentScreenPerms.allSections,
            edit: anyChecked,
            sections: updatedSections,
          },
        };
      }

      // Handle other permissions
      const updatedScreenPerms = {
        ...currentScreenPerms,
        [permissionType]: checked,
        sections: updatedSections,
      };

      if (permissionType === "print" && checked) {
        updatedScreenPerms.download = true;
      }

      return {
        ...prev,
        [screenId]: updatedScreenPerms,
      };
    });
  };

  // Handle screen table row selection
  const handleScreenTableRowSelection = (newSelectedRows) => {
    isUpdatingFromScreenTable.current = true;
    setSelectedScreens(newSelectedRows);
    setTimeout(() => {
      isUpdatingFromScreenTable.current = false;
    }, 0);
  };

  // Handle delete screen
  const handleDeleteScreen = (screenId) => {
    setAllSelectedScreensData((prev) => prev.filter((o) => o.id !== screenId));
    setSelectedScreens((prev) => prev.filter((id) => id !== screenId));
    const updatedPermissions = { ...permissions };
    delete updatedPermissions[screenId];
    setPermissions(updatedPermissions);
  };

  // Report table headers
  const reportHeaders = [
    "Report ID",
    "Report Name",
    "Report Description",
    "Print & Download",
  ];

  // Build report table data - NOW USES allSelectedReportsData instead of reportOptions
  const reportTableData = (
    Array.isArray(selectedReports) ? selectedReports : []
  )
    .map((reportId) => {
      const opt = allSelectedReportsData.find((o) => o.id === reportId);
      if (!opt || !opt.fullData) return null;

      const report = opt.fullData;
      const perms = reportPermissions[report.report_id] || {};

      return [
        report.report_id,
        report.display_name,
        report.report_desc,

        // Print
        <input
          type="checkbox"
          className="cr-custom-checkbox"
          checked={perms.print || false}
          onChange={(e) =>
            handleReportPermissionChange(
              report.report_id,
              "print",
              e.target.checked
            )
          }
        />,

        // Download
        // <input
        //   type="checkbox"
        //   className="cr-custom-checkbox"
        //   checked={perms.download || false}
        //   onChange={(e) =>
        //     handleReportPermissionChange(report.report_id, "download", e.target.checked)
        //   }
        // />,
      ];
    })
    .filter(Boolean);

  // Handle report permission changes
  const handleReportPermissionChange = (reportId, type, checked) => {
    setReportPermissions((prev) => {
      const updated = {
        ...prev,
        [reportId]: {
          ...prev[reportId],
          [type]: checked,
        },
      };

      // Auto-select DOWNLOAD when PRINT is checked
      if (type === "print" && checked) {
        updated[reportId].download = true;
      }

      return updated;
    });
  };

  // Handle report table row selection
  const handleReportTableRowSelection = (newSelectedRows) => {
    isUpdatingFromReportTable.current = true;
    setSelectedReports(newSelectedRows);
    setTimeout(() => {
      isUpdatingFromReportTable.current = false;
    }, 0);
  };

  // Handle delete report
  const handleDeleteReport = (reportId) => {
    setAllSelectedReportsData((prev) => prev.filter((o) => o.id !== reportId));
    setSelectedReports((prev) => prev.filter((id) => id !== reportId));
    const updated = { ...reportPermissions };
    delete updated[reportId];
    setReportPermissions(updated);
  };

  // 2. Add this validation function before handleSave
  const validateScreenPermissions = () => {
    const screensWithoutPermissions = [];

    selectedScreens.forEach((screenId) => {
      const opt = allSelectedScreensData.find((o) => o.id === screenId);
      if (!opt || !opt.fullData) return;

      const screen = opt.fullData;
      const perms = permissions[screen.screen_id] || {};

      // Check if at least one permission is selected
      const hasAnyPermission =
        perms.create || perms.read || perms.delete || perms.print || perms.edit;

      if (!hasAnyPermission) {
        screensWithoutPermissions.push(screen.screen_name);
      }
    });

    return screensWithoutPermissions;
  };

  // const handleSave = async () => {

  //   let errorMessage = "";
  //     if (!roleName || roleName.trim() === "") {
  //       errorMessage = "Role Name is required.";
  //     }
  //     else if (!roleCode || roleCode.trim() === "") {
  //       errorMessage = "Role Code is required.";
  //     }
  //     else if (!description || description.trim() === "") {
  //       errorMessage = "Role Description is required.";
  //     }

  //     if (errorMessage) {
  //       setIsMessageBoxVisible(true);
  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <span>{errorMessage}</span>
  //           </div>
  //         </div>
  //       );
  //       setActiveImg(ErrorIcon);
  //       return;
  //     }

  //     let errors = [];
  //     if (!roleName) {
  //       setRoleNameError(true);
  //       errors.push("Role Name");
  //     }

  //     if (!roleCode) {
  //       setRoleCodeError(true);
  //       errors.push("Role Code");
  //     }

  //     if (!description) {
  //       setDescriptionError(true);
  //       errors.push("Role Description");
  //     }

  //     if (roleNameError) errors.push("Role Name");
  //     if (roleCodeError) errors.push("Role Code");
  //     if (descriptionError) errors.push("Role Description");

  //     if (errors.length > 0) {
  //       const messageText =
  //         errors.length === 1
  //         ? `Please correct the highlighted field: ${errors[0]}!`
  //         : `Please correct the highlighted fields: ${errors.join(" and ")}!`;

  //     setIsMessageBoxVisible(true);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <span>{messageText}</span>
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(ErrorIcon);
  //     return;
  //   }

  //  // At least one screen OR one report must be selected
  //   if (selectedScreens.length === 0 && selectedReports.length === 0) {
  //     setIsMessageBoxVisible(true);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <span>Please select at least one Screen or one Report!</span>
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(ErrorIcon);
  //     return;
  //   }

  // // NEW: Validate that each screen has at least one permission
  // const screensWithoutPermissions = validateScreenPermissions();
  //   if (screensWithoutPermissions.length > 0) {
  //     const screenNames = screensWithoutPermissions.join(", ");
  //     setIsMessageBoxVisible(true);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <span>
  //             Please select at least one permission (Create, Read, Delete, or Print & Download)
  //             for the following screen{screensWithoutPermissions.length > 1 ? 's' : ''}: {screenNames}
  //           </span>
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(ErrorIcon);
  //     return;
  //   }

  //   const role_screen_list = selectedScreens.flatMap((screenId) => {
  //     const opt = allSelectedScreensData.find(o => o.id === screenId);
  //     if (!opt || !opt.fullData) return [];

  //     const screen = opt.fullData;
  //     const perms = permissions[screen.screen_id] || {};

  //     if (screen.sections && screen.sections.length > 0) {
  //       return screen.sections.map((section) => ({
  //         role_id: 0,
  //         screen_id: screen.screen_id,
  //         wb_scr_sec_id: section.sec_id,
  //         client_id: clientId,
  //         create_perm: perms.create ? 1 : 0,
  //         read_perm: perms.read ? 1 : 0,
  //         update_perm: perms.sections?.[section.sec_id]?.edit ? 1 : 0,
  //         delete_perm: perms.delete ? 1 : 0,
  //         create_date: new Date().toISOString(),
  //         created_by: userName,
  //         last_modified_by: userName,
  //         last_modified_date: new Date().toISOString(),
  //         print: perms.print ? 1 : 0,
  //         // download: perms.download ? 1 : 0,
  //       }));
  //     }

  //     return {
  //       role_id: 0,
  //       screen_id: screen.screen_id,
  //       wb_scr_sec_id: null,
  //       client_id: clientId,
  //       create_perm: perms.create ? 1 : 0,
  //       read_perm: perms.read ? 1 : 0,
  //       update_perm: perms.edit ? 1 : 0,
  //       delete_perm: perms.delete ? 1 : 0,
  //       create_date: new Date().toISOString(),
  //       created_by: userName,
  //       last_modified_by: userName,
  //       last_modified_date: new Date().toISOString(),
  //       print: perms.print ? 1 : 0,
  //       // download: perms.download ? 1 : 0,
  //     };
  //   });

  //   const role_report_list = selectedReports.map((reportId) => {
  //     const opt = allSelectedReportsData.find(o => o.id === reportId);
  //     if (!opt || !opt.fullData) return null;

  //     const report = opt.fullData;
  //     const perms = reportPermissions[report.report_id] || {};

  //     return {
  //       role_id: 0,
  //       report_id: report.report_id,
  //       client_id: clientId,
  //       create_date: new Date().toISOString(),
  //       created_by: userName,
  //       last_modified_by: userName,
  //       last_modified_date: new Date().toISOString(),
  //       print: perms.print ? 1 : 0,
  //       // download: perms.download ? 1 : 0,
  //     };
  //   }).filter(Boolean);

  //   const roleNameTrimmed = (roleName).trim();
  //   const roleCodeTrimmed = (roleCode).trim();
  //   const descriptionTrimmed = (description).trim();

  //   try {
  //     const url = `${FULL_API_BASE_URL}/new-role-v2?client_id=${clientId}&role_code=${roleCodeTrimmed}&role_name=${roleNameTrimmed}&role_desc=${descriptionTrimmed}&user_name=${userName}&status=1&client_branch_id=${clientBranchId}`;

  //     const response = await fetch(url, {
  //       method: "POST",
  //       headers: {
  //         accept: "application/json",
  //         Authorization: `Bearer ${accessToken}`,
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         role_screen_list,
  //         role_report_list,
  //       }),
  //     });

  //     const result = await response.json();

  //     // if (response.status === 409 && response.message === "Role Code already exists for this branch.") {
  //     //   setIsMessageBoxVisible(true);
  //     //   setMessageBox(
  //     //     <div className="Container-messageBOX">
  //     //       <div className="messagebox-insider1">
  //     //         <span>{"Role already exists!"}</span>
  //     //       </div>
  //     //     </div>
  //     //   );
  //     //   setActiveImg(WarningIcon);
  //     //   return;
  //     // }

  //     if (response.status === 409 && response.message === "Role already exists for this branch.") {
  //       setIsMessageBoxVisible(true);
  //       let errorMessage = "Role already exists!";
  //       if (result.message.includes("Role Code") && result.role_code) {
  //         errorMessage = `Role code "${result.role_code}" already exists!`;
  //       } else if (result.message.includes("Role") && result.role_name) {
  //         errorMessage = `Role "${result.role_name}" already exists!`;
  //       }

  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <span>{errorMessage}</span>
  //           </div>
  //         </div>
  //       );
  //       setActiveImg(WarningIcon);
  //       return;
  //     }

  //     if (response.status === 200 && response.message === "Role created successfully!") {
  //       setIsMessageBoxVisible(true);
  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <div className="loader-tc"></div>
  //             <span>{result.message || "Role created successfully!"}</span>
  //           </div>
  //         </div>
  //       );
  //       setActiveImg(InterogativeImg);
  //       // console.log("response ok", response.status);
  //       console.log("Role created successfully:", result);
  //       setTimeout(() => navigate("/create_role_dashboard"), 1000);
  //     } else {
  //       throw new Error(result.message || "Failed to create role");
  //     }
  //   } catch (error) {
  //     console.error("Error creating role:", error);
  //     setIsMessageBoxVisible(true);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>{`Error: ${error.message}`}</span>
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(InterogativeImg);
  //   }
  // };

  const handleSave = async () => {
    let errorMessage = "";
    if (!roleName || roleName.trim() === "") {
      errorMessage = "Role Name is required.";
    } else if (!roleCode || roleCode.trim() === "") {
      errorMessage = "Role Code is required.";
    } else if (!description || description.trim() === "") {
      errorMessage = "Role Description is required.";
    }

    if (errorMessage) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>{errorMessage}</span>
          </div>
        </div>
      );
      setActiveImg(ErrorIcon);
      return;
    }

    let errors = [];
    if (!roleName) {
      setRoleNameError(true);
      errors.push("Role Name");
    }

    if (!roleCode) {
      setRoleCodeError(true);
      errors.push("Role Code");
    }

    if (!description) {
      setDescriptionError(true);
      errors.push("Role Description");
    }

    if (roleNameError) errors.push("Role Name");
    if (roleCodeError) errors.push("Role Code");
    if (descriptionError) errors.push("Role Description");

    if (errors.length > 0) {
      const messageText =
        errors.length === 1
          ? `Please correct the highlighted field: ${errors[0]}!`
          : `Please correct the highlighted fields: ${errors.join(" and ")}!`;

      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>{messageText}</span>
          </div>
        </div>
      );
      setActiveImg(ErrorIcon);
      return;
    }

    // At least one screen OR one report must be selected
    if (selectedScreens.length === 0 && selectedReports.length === 0) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>Please select at least one Screen or one Report!</span>
          </div>
        </div>
      );
      setActiveImg(ErrorIcon);
      return;
    }

    // Removed validation for screen permissions since READ is always selected

    const role_screen_list = selectedScreens.flatMap((screenId) => {
      const opt = allSelectedScreensData.find((o) => o.id === screenId);
      if (!opt || !opt.fullData) return [];

      const screen = opt.fullData;
      const perms = permissions[screen.screen_id] || {};

      if (screen.sections && screen.sections.length > 0) {
        return screen.sections.map((section) => ({
          role_id: 0,
          screen_id: screen.screen_id,
          wb_scr_sec_id: section.sec_id,
          client_id: clientId,
          create_perm: perms.create ? 1 : 0,
          read_perm: 1,
          update_perm: perms.sections?.[section.sec_id]?.edit ? 1 : 0,
          delete_perm: perms.delete ? 1 : 0,
          create_date: new Date().toISOString(),
          created_by: userName,
          last_modified_by: userName,
          last_modified_date: new Date().toISOString(),
          print: perms.print ? 1 : 0,
        }));
      }

      return {
        role_id: 0,
        screen_id: screen.screen_id,
        wb_scr_sec_id: null,
        client_id: clientId,
        create_perm: perms.create ? 1 : 0,
        read_perm: 1,
        update_perm: perms.edit ? 1 : 0,
        delete_perm: perms.delete ? 1 : 0,
        create_date: new Date().toISOString(),
        created_by: userName,
        last_modified_by: userName,
        last_modified_date: new Date().toISOString(),
        print: perms.print ? 1 : 0,
      };
    });

    const role_report_list = selectedReports
      .map((reportId) => {
        const opt = allSelectedReportsData.find((o) => o.id === reportId);
        if (!opt || !opt.fullData) return null;

        const report = opt.fullData;
        const perms = reportPermissions[report.report_id] || {};

        return {
          role_id: 0,
          report_id: report.report_id,
          client_id: clientId,
          create_date: new Date().toISOString(),
          created_by: userName,
          last_modified_by: userName,
          last_modified_date: new Date().toISOString(),
          print: perms.print ? 1 : 0,
        };
      })
      .filter(Boolean);

    const roleNameTrimmed = roleName.trim();
    const roleCodeTrimmed = roleCode.trim();
    const descriptionTrimmed = description.trim();

    try {
      const url = `${FULL_API_BASE_URL}/new-role-v2?client_id=${clientId}&role_code=${roleCodeTrimmed}&role_name=${roleNameTrimmed}&role_desc=${descriptionTrimmed}&user_name=${userName}&status=1&client_branch_id=${clientBranchId}`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          role_screen_list,
          role_report_list,
        }),
      });

      const result = await response.json();

      // FIXED: Check result.status instead of response.status
      if (result.status === 409) {
        setIsMessageBoxVisible(true);
        let errorMessage = "Role already exists!";
        if (result.message.includes("Role Code") && result.role_code) {
          errorMessage = `Role Code "${result.role_code}" already exists!`;
        } else if (result.message.includes("Role") && result.role_name) {
          errorMessage = `Role Name "${result.role_name}" already exists!`;
        }

        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>{errorMessage}</span>
            </div>
          </div>
        );
        setActiveImg(WarningIcon);
        return;
      }

      // FIXED: Check result.status instead of response.status
      if (result.status === 200) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{result.message || "Role created successfully!"}</span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);
        console.log("Role created successfully:", result);
        setTimeout(() => navigate("/create_role_dashboard"), 1000);
      } else {
        throw new Error(result.message || "Failed to create role");
      }
    } catch (error) {
      console.error("Error creating role:", error);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{`Error: ${error.message}`}</span>
          </div>
        </div>
      );
      setActiveImg(ErrorIcon); // Changed to ErrorIcon for consistency
    }
  };
  const toggleAccordionDetails = () => setIsOpenDetails((prev) => !prev);

  const [roleNameError, setRoleNameError] = useState(false);
  const [roleCodeError, setRoleCodeError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);

  const handleRoleNameChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[^A-Za-z0-9-_ ]/g, "");
    setRoleName(value);
    const regex = /^[A-Za-z][A-Za-z0-9-_ ]*$/;
    if (value === "" || !regex.test(value)) {
      setRoleNameError(true);
    } else {
      setRoleNameError(false);
    }
  };

  const handleRoleCodeChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[^A-Za-z0-9-]/g, "");
    if (value.length > 10) {
      value = value.slice(0, 10);
    }
    setRoleCode(value);
    if (value.trim() === "") {
      setRoleCodeError(true);
    } else {
      setRoleCodeError(false);
    }
  };

  const handleDescriptionChange = (e) => {
    const value = e.target.value;

    setDescription(value);
    if (value.trim() === "") {
      setDescriptionError(true);
    } else {
      setDescriptionError(false);
    }
  };

  return (
    <div className="create-role-container">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">Create Role</span>
        <div className="cr-header-btn-container">
          <button
            className="cr-cancel-btn"
            onClick={() => navigate("/create_role_dashboard")}
          >
            CANCEL
          </button>
          <button className="cr-create-btn" onClick={handleSave}>
            SAVE
          </button>
        </div>
      </div>

      {/* DETAILS SECTION */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>ROLE DETAILS</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordionDetails}>
            {isOpenDetails ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isOpenDetails && (
          <div className="accordion-content">
            <div className="select-assign-test-container-ques-pap-del">
              <div className="grid-container-ques-paper-del">
                <div className="item1">
                  {/* <FormInputs
                  label="Role Name"
                  type="text"
                  required
                  value={roleName}
                  onChange={(e) => setRoleName(e.target.value)}
                /> */}
                  <FormInputs
                    label="Role Name"
                    type="text"
                    required
                    value={roleName}
                    onChange={handleRoleNameChange}
                    className={roleNameError ? "input-error" : ""}
                    maxlength="200"
                  />
                </div>
                <div className="item2">
                  {/* <FormInputs
                  label="Role Code"
                  type="text"
                  required
                  value={roleCode}
                  onChange={(e) => setRoleCode(e.target.value)}
                /> */}
                  <FormInputs
                    label="Role Code"
                    type="text"
                    required
                    value={roleCode}
                    onChange={handleRoleCodeChange}
                    className={roleCodeError ? "input-error" : ""}
                    maxlength="10"
                  />
                </div>
                {/* <div className="item4-creaete-role-description" style={{ gridColumn: "1 / -1"}}> */}
                <div>
                  <FormInputs
                    label="Description"
                    type="text"
                    value={description}
                    onChange={handleDescriptionChange}
                    className={descriptionError ? "input-error" : ""}
                    required
                    maxlength="200"
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* ADD SCREENS SECTION */}
      <div className="ques-paper-del" style={{ marginTop: "20px" }}>
        <div className="personal-header">
          <div className="header">
            <label>ADD SCREENS</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordionShareBranch}>
            {isOpenShareBranch ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>

        {isOpenShareBranch && (
          <div className="accordion-content">
            <div
              className="select-assign-test-container-ques-pap-del"
              style={{ padding: "20px 0px 20px 0px" }}
            >
              <div className="grid-container-ques-paper-del">
                <div className="item1" style={{ marginLeft: "20px" }}>
                  <DropdownWithPagination
                    label="Search Screen"
                    width="100%"
                    selected={selectedScreens}
                    setSelected={setSelectedScreens}
                    onSearchInputChange={fetchScreens}
                    options={screenOptions}
                    isRequired={false}
                    showSelectAll={false}
                    allowMultiple={true}
                    itemsPerPage={4}
                    placeholder="Type Screen Name..."
                  />
                </div>
                <div style={{ gridColumn: "1 / -1", marginTop: 16 }}>
                  <TableWithCrossSelections
                    headers={headers}
                    data={tableData}
                    searchPlaceholder="Search screens..."
                    selectedRows={selectedScreens}
                    setSelectedRows={handleScreenTableRowSelection}
                    renderQuestionText={(text) => text}
                    renderQuestionTextModel={(text) => text}
                    expandedStates={{}}
                    toggleImage={() => {}}
                    pageType="userEdit"
                    onRowLinkClick={(row) => console.log("Row clicked:", row)}
                    filterConfig={{}}
                    handleDeleteRow={handleDeleteScreen}
                    hideIdColumn={true}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* ADD REPORTS SECTION */}
      <div className="ques-paper-del" style={{ marginTop: "20px" }}>
        <div className="personal-header">
          <div className="header">
            <label>ADD REPORTS</label>
          </div>
          <div
            className="accordion-btn"
            onClick={() => setIsOpenReports((p) => !p)}
          >
            {isOpenReports ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>

        {isOpenReports && (
          <div className="accordion-content">
            <div
              className="select-assign-test-container-ques-pap-del"
              style={{ padding: "20px 0px 20px 0px" }}
            >
              <div className="grid-container-ques-paper-del">
                <div className="item1" style={{ marginLeft: "20px" }}>
                  <DropdownWithPagination
                    label="Search Report"
                    width="100%"
                    selected={selectedReports}
                    setSelected={setSelectedReports}
                    onSearchInputChange={fetchReports}
                    options={reportOptions}
                    isRequired={false}
                    showSelectAll={false}
                    allowMultiple={true}
                    itemsPerPage={4}
                    placeholder="Type Report Name..."
                  />
                </div>
                <div style={{ gridColumn: "1 / -1", marginTop: 16 }}>
                  <TableWithCrossStudentGroup
                    headers={reportHeaders}
                    data={reportTableData}
                    searchPlaceholder="Search reports..."
                    selectedRows={selectedReports}
                    setSelectedRows={handleReportTableRowSelection}
                    renderQuestionText={(text) => text}
                    renderQuestionTextModel={(text) => text}
                    expandedStates={{}}
                    toggleImage={() => {}}
                    pageType="userEdit"
                    onRowLinkClick={(row) =>
                      console.log("Report clicked:", row)
                    }
                    filterConfig={{}}
                    handleDeleteRow={handleDeleteReport}
                    hideIdColumn={true}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default NewCreateRole;

//TESTED COMPONENT
// import React, { useState, useRef, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
// import Dropdown from "../../../Components/Shared/Dropdown/Dropdown";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Informative.png";
// import { fetchRoleData } from "../../../Redux/features/CreateRole/createRoleSlice";
// import TableWithCrossStudentGroup from "../../StudentGrouph/TableWithCrossStudentGroup";
// import TableWithCrossSelections from "./TableWithCrossSelections";
// import DropdownWithPagination from "../../StudentGrouph/DropdownWithPagination";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import "./updatecreaterole.css";

// function NewCreateRole({
//   dataClient,
//   setMessageBox,
//   messageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
// }) {
//   const navigate = useNavigate();
//   const isUpdatingFromScreenTable = useRef(false);
//   const isUpdatingFromReportTable = useRef(false);

//   const [isOpenShareBranch, setIsOpenShareBranch] = useState(true);
//   const [roleName, setRoleName] = useState("");
//   const [roleCode, setRoleCode] = useState("");
//   const [status, setStatus] = useState(null);
//   const [description, setDescription] = useState("");

//   // Screen states
//   const [selectedScreens, setSelectedScreens] = useState([]);
//   const [screenOptions, setScreenOptions] = useState([]);
//   const [permissions, setPermissions] = useState({});
//   const [expandedScreens, setExpandedScreens] = useState({});

//   // Reports section states
//   const [isOpenReports, setIsOpenReports] = useState(true);
//   const [selectedReports, setSelectedReports] = useState([]);
//   const [reportOptions, setReportOptions] = useState([]);
//   const [reportPermissions, setReportPermissions] = useState({});

//   const [isOpenDetails, setIsOpenDetails] = useState(true);
//   const { data, loading, error } = useSelector((state) => state.createRole);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(fetchRoleData());
//   }, [dispatch]);

//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name;
//   const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id;
//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
//   const accessToken = localStorage.getItem("other");

//   // Fetch screens based on search key
//   const fetchScreens = async (searchKey) => {
//     if (!searchKey || searchKey.trim().length < 2) {
//       setScreenOptions([]);
//       return;
//     }

//     try {
//       const filtered = data.filter((item) =>
//         item.screen_name.toLowerCase().includes(searchKey.toLowerCase())
//       );

//       const formattedOptions = filtered.map((screen) => ({
//         id: screen.screen_id,
//         label: screen.screen_name,
//         fullData: screen,
//       }));

//       setScreenOptions(formattedOptions);
//     } catch (error) {
//       console.error("Error fetching screens:", error);
//       setScreenOptions([]);
//     }
//   };

//   // Fetch reports based on search key
//   const fetchReports = async (searchKey) => {
//     if (!searchKey || searchKey.trim().length < 2) {
//       setReportOptions([]);
//       return;
//     }

//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-report-list-by-search-key?search_key=${searchKey}`,
//         {
//           method: "GET",
//           headers: {
//             accept: "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//         }
//       );
//       const result = await response.json();

//       if (result.status === 200 && result.data) {
//         const formattedOptions = result.data.map((report) => ({
//           id: report.report_id,
//           label: report.display_name,
//           fullData: report,
//         }));
//         setReportOptions(formattedOptions);
//       } else {
//         setReportOptions([]);
//       }
//     } catch (error) {
//       console.error("Error fetching reports:", error);
//       setReportOptions([]);
//     }
//   };

//   const toggleAccordionShareBranch = () => setIsOpenShareBranch((prev) => !prev);

//   const toggleExpand = (screenId) => {
//     setExpandedScreens((prev) => ({
//       ...prev,
//       [screenId]: !prev[screenId],
//     }));
//   };

//   // Screen table headers
//   const headers = [
//     "Screen ID",
//     "Screen Name",
//     "Edit",
//     "Create",
//     "Read",
//     "Delete",
//     "Print",
//     "Download",
//   ];

//   // Build screen table data
//   const tableData = (Array.isArray(selectedScreens) ? selectedScreens : [])
//     .map((screenId) => {
//       const opt = screenOptions.find((o) => o.id === screenId);
//       if (!opt || !opt.fullData) return null;

//       const screen = opt.fullData;
//       const perms = permissions[screen.screen_id] || {};
//       const isExpanded = expandedScreens[screen.screen_id];
//       const sectionList = screen.sections || [];
//       const hasSections = sectionList.length > 0;

//       return [
//         screenId,
//         screen.screen_name,
//         <div style={{ display: "flex", flexDirection: "column" }}>
//           <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//             {hasSections && (
//               <>
//                 <input
//                   type="checkbox"
//                   className="cr-custom-checkbox"
//                   checked={perms.allSections || false}
//                   onChange={(e) => {
//                     const checked = e.target.checked;
//                     handlePermissionChange(screen.screen_id, null, "allSections", checked);
//                   }}
//                 />

//                 <span
//                   onClick={() => toggleExpand(screen.screen_id)}
//                   style={{
//                     cursor: "pointer",
//                     fontWeight: "bold",
//                     marginLeft: "8px",
//                     userSelect: "none",
//                   }}
//                 >
//                   {isExpanded ? "−" : "+"}
//                 </span>

//                 <span style={{ marginLeft: "8px", marginRight: "20px" }}>
//                   All Sections
//                 </span>
//               </>
//             )}

//             {!hasSections && (
//               <input
//                 type="checkbox"
//                 className="cr-custom-checkbox"
//                 checked={perms.edit || false}
//                 onChange={(e) =>
//                   handlePermissionChange(screen.screen_id, null, "edit", e.target.checked)
//                 }
//               />
//             )}
//           </div>

//           {hasSections && isExpanded && (
//             <div
//               style={{
//                 marginTop: "10px",
//                 display: "flex",
//                 marginLeft: "24px",
//                 flexDirection: "column",
//                 gap: "10px",
//               }}
//             >
//               {sectionList.map((section) => {
//                 const secPerm = perms.sections?.[section.sec_id]?.edit || false;
//                 return (
//                   <label key={section.sec_id} style={{ display: "flex", gap: "6px" }}>
//                     <input
//                       type="checkbox"
//                       className="cr-custom-checkbox"
//                       checked={secPerm}
//                       onChange={(e) => {
//                         handlePermissionChange(
//                           screen.screen_id,
//                           section.sec_id,
//                           "edit",
//                           e.target.checked
//                         );
//                       }}
//                     />
//                     {section.sec_name}
//                   </label>
//                 );
//               })}
//             </div>
//           )}
//         </div>,

//         // Create
//         <input
//           type="checkbox"
//           className="cr-custom-checkbox"
//           checked={perms.create || false}
//           onChange={(e) =>
//             handlePermissionChange(screen.screen_id, null, "create", e.target.checked)
//           }
//         />,

//         // Read
//         <input
//           type="checkbox"
//           className="cr-custom-checkbox"
//           checked={perms.read || false}
//           onChange={(e) =>
//             handlePermissionChange(screen.screen_id, null, "read", e.target.checked)
//           }
//         />,

//         // Delete
//         <input
//           type="checkbox"
//           className="cr-custom-checkbox"
//           checked={perms.delete || false}
//           onChange={(e) =>
//             handlePermissionChange(screen.screen_id, null, "delete", e.target.checked)
//           }
//         />,

//         // Print
//         <input
//           type="checkbox"
//           className="cr-custom-checkbox"
//           checked={perms.print || false}
//           onChange={(e) =>
//             handlePermissionChange(screen.screen_id, null, "print", e.target.checked)
//           }
//         />,

//         // Download
//         <input
//           type="checkbox"
//           className="cr-custom-checkbox"
//           checked={perms.download || false}
//           onChange={(e) =>
//             handlePermissionChange(screen.screen_id, null, "download", e.target.checked)
//           }
//         />,
//       ];
//     })
//     .filter(Boolean);

//   // Handle permission changes
//   const handlePermissionChange = (screenId, secId, permissionType, checked) => {
//     setPermissions((prev) => {
//       const currentScreenPerms = prev[screenId] || {};
//       const currentSections = currentScreenPerms.sections || {};
//       const updatedSections = { ...currentSections };
//       const screen = screenOptions.find(o => o.fullData?.screen_id === screenId)?.fullData;
//       const sectionList = screen?.sections || [];

//       // Handle "All Sections" checkbox
//       if (permissionType === "allSections") {
//         const newSections = {};
//         sectionList.forEach(sec => {
//           newSections[sec.sec_id] = {
//             ...(updatedSections[sec.sec_id] || {}),
//             edit: checked,
//           };
//         });

//         return {
//           ...prev,
//           [screenId]: {
//             ...currentScreenPerms,
//             allSections: checked,
//             edit: checked,
//             sections: newSections,
//           },
//         };
//       }

//       // Handle individual section checkbox
//       if (secId) {
//         updatedSections[secId] = {
//           ...(updatedSections[secId] || {}),
//           edit: checked,
//         };

//         const allChecked = sectionList.every(sec => updatedSections[sec.sec_id]?.edit);
//         const allUnchecked = sectionList.every(sec => !updatedSections[sec.sec_id]?.edit);
//         const anyChecked = sectionList.some(sec => updatedSections[sec.sec_id]?.edit);

//         return {
//           ...prev,
//           [screenId]: {
//             ...currentScreenPerms,
//             allSections: allChecked ? true : (allUnchecked ? false : currentScreenPerms.allSections),
//             edit: anyChecked,
//             sections: updatedSections,
//           },
//         };
//       }

//       // Handle other permissions
//       const updatedScreenPerms = {
//         ...currentScreenPerms,
//         [permissionType]: checked,
//         sections: updatedSections,
//       };

//       if (permissionType === "print" && checked) {
//         updatedScreenPerms.download = true;
//       }

//       return {
//         ...prev,
//         [screenId]: updatedScreenPerms,
//       };
//     });
//   };

//   // Handle screen table row selection
//   const handleScreenTableRowSelection = (newSelectedRows) => {
//     isUpdatingFromScreenTable.current = true;
//     setSelectedScreens(newSelectedRows);
//     setTimeout(() => {
//       isUpdatingFromScreenTable.current = false;
//     }, 0);
//   };

//   // Handle delete screen
//   const handleDeleteScreen = (screenId) => {
//     setScreenOptions((prev) => prev.filter((o) => o.id !== screenId));
//     setSelectedScreens((prev) => prev.filter((id) => id !== screenId));
//     const updatedPermissions = { ...permissions };
//     delete updatedPermissions[screenId];
//     setPermissions(updatedPermissions);
//   };

//   // Report table headers
//   const reportHeaders = ["Report ID", "Report Name", "Print", "Download"];

//   // Build report table data
//   const reportTableData = (Array.isArray(selectedReports) ? selectedReports : [])
//     .map((reportId) => {
//       const opt = reportOptions.find((o) => o.id === reportId);
//       if (!opt || !opt.fullData) return null;

//       const report = opt.fullData;
//       const perms = reportPermissions[report.report_id] || {};

//       return [
//         report.report_id,
//         report.display_name,

//         // Print
//         <input
//           type="checkbox"
//           className="cr-custom-checkbox"
//           checked={perms.print || false}
//           onChange={(e) =>
//             handleReportPermissionChange(report.report_id, "print", e.target.checked)
//           }
//         />,

//         // Download
//         <input
//           type="checkbox"
//           className="cr-custom-checkbox"
//           checked={perms.download || false}
//           onChange={(e) =>
//             handleReportPermissionChange(report.report_id, "download", e.target.checked)
//           }
//         />,
//       ];
//     })
//     .filter(Boolean);

//   // Handle report permission changes
//   // const handleReportPermissionChange = (reportId, type, checked) => {
//   //   setReportPermissions((prev) => ({
//   //     ...prev,
//   //     [reportId]: {
//   //       ...prev[reportId],
//   //       [type]: checked,
//   //     },
//   //   }));
//   // };

//   const handleReportPermissionChange = (reportId, type, checked) => {
//   setReportPermissions((prev) => {
//     const updated = {
//       ...prev,
//       [reportId]: {
//         ...prev[reportId],
//         [type]: checked,
//       },
//     };

//     // Auto-select DOWNLOAD when PRINT is checked
//     if (type === "print" && checked) {
//       updated[reportId].download = true;
//     }

//     return updated;
//   });
// };

//   // Handle report table row selection
//   const handleReportTableRowSelection = (newSelectedRows) => {
//     isUpdatingFromReportTable.current = true;
//     setSelectedReports(newSelectedRows);
//     setTimeout(() => {
//       isUpdatingFromReportTable.current = false;
//     }, 0);
//   };

//   // Handle delete report
//   const handleDeleteReport = (reportId) => {
//     setReportOptions((prev) => prev.filter((o) => o.id !== reportId));
//     setSelectedReports((prev) => prev.filter((id) => id !== reportId));
//     const updated = { ...reportPermissions };
//     delete updated[reportId];
//     setReportPermissions(updated);
//   };

//   const handleSave = async () => {
//     if (!roleName || !roleCode || !description) {
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Please fill all required fields!</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//       return;
//     }

//     const role_screen_list = selectedScreens.flatMap((screenId) => {
//       const opt = screenOptions.find(o => o.id === screenId);
//       if (!opt || !opt.fullData) return [];

//       const screen = opt.fullData;
//       const perms = permissions[screen.screen_id] || {};

//       if (screen.sections && screen.sections.length > 0) {
//         return screen.sections.map((section) => ({
//           role_id: 0,
//           screen_id: screen.screen_id,
//           wb_scr_sec_id: section.sec_id,
//           client_id: clientId,
//           create_perm: perms.create ? 1 : 0,
//           read_perm: perms.read ? 1 : 0,
//           // update_perm: perms.sections?.[section.sec_id]?.edit || perms.edit ? 1 : 0,
//           update_perm: perms.sections?.[section.sec_id]?.edit ? 1 : 0,
//           delete_perm: perms.delete ? 1 : 0,
//           create_date: new Date().toISOString(),
//           created_by: userName,
//           last_modified_by: userName,
//           last_modified_date: new Date().toISOString(),
//           print: perms.print ? 1 : 0,
//           download: perms.download ? 1 : 0,
//         }));
//       }

//       return {
//         role_id: 0,
//         screen_id: screen.screen_id,
//         wb_scr_sec_id: null,
//         client_id: clientId,
//         create_perm: perms.create ? 1 : 0,
//         read_perm: perms.read ? 1 : 0,
//         update_perm: perms.edit ? 1 : 0,
//         delete_perm: perms.delete ? 1 : 0,
//         create_date: new Date().toISOString(),
//         created_by: userName,
//         last_modified_by: userName,
//         last_modified_date: new Date().toISOString(),
//         print: perms.print ? 1 : 0,
//         download: perms.download ? 1 : 0,
//       };
//     });

//     const role_report_list = selectedReports.map((reportId) => {
//       const opt = reportOptions.find(o => o.id === reportId);
//       if (!opt || !opt.fullData) return null;

//       const report = opt.fullData;
//       const perms = reportPermissions[report.report_id] || {};

//       return {
//         role_id: 0,
//         report_id: report.report_id,
//         client_id: clientId,
//         create_date: new Date().toISOString(),
//         created_by: userName,
//         last_modified_by: userName,
//         last_modified_date: new Date().toISOString(),
//         print: perms.print ? 1 : 0,
//         download: perms.download ? 1 : 0,
//       };
//     }).filter(Boolean);

//     try {
//       const url = `${FULL_API_BASE_URL}/new-role-v2?client_id=${clientId}&role_code=${roleCode}&role_name=${roleName}&role_desc=${description}&user_name=${userName}&status=1&client_branch_id=${clientBranchId}`;

//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           accept: "application/json",
//           Authorization: `Bearer ${accessToken}`,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           role_screen_list,
//           role_report_list,
//         }),
//       });

//       const result = await response.json();

//       if (response.ok) {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{result.message || "Role created successfully!"}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(InterogativeImg);

//         setTimeout(() => navigate("/create_role_dashboard"), 1000);
//       } else {
//         throw new Error(result.message || "Failed to create role");
//       }
//     } catch (error) {
//       console.error("Error creating role:", error);
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{`Error: ${error.message}`}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//     }
//   };

//   const toggleAccordionDetails = () => setIsOpenDetails((prev) => !prev);

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">Create Role</span>
//         <div className="cr-header-btn-container">
//           <button
//             className="cr-cancel-btn"
//             onClick={() => navigate("/create_role_dashboard")}
//           >
//             CANCEL
//           </button>
//           <button className="cr-create-btn" onClick={handleSave}>
//             SAVE
//           </button>
//         </div>
//       </div>

//       {/* DETAILS SECTION */}
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>DETAILS</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleAccordionDetails}>
//             {isOpenDetails ? (
//               <div className="minus"></div>
//             ) : (
//               <div className="plus">+</div>
//             )}
//           </div>
//         </div>
//         {isOpenDetails &&
//         (
//             <div className="accordion-content">
//           <div className="select-assign-test-container-ques-pap-del">
//             <div className="grid-container-ques-paper-del">
//               <div className="item1">
//                 <FormInputs
//                   label="Role Name"
//                   type="text"
//                   required
//                   value={roleName}
//                   onChange={(e) => setRoleName(e.target.value)}
//                 />
//               </div>

//               <div className="item2">
//                 <FormInputs
//                   label="Role Code"
//                   type="text"
//                   required
//                   value={roleCode}
//                   onChange={(e) => setRoleCode(e.target.value)}
//                 />
//               </div>

//               <div className="item4-creaete-role-description" style={{ gridColumn: "1 / -1"}}>
//                 <FormInputs
//                   label="Description"
//                   type="textarea"
//                   value={description}
//                   onChange={(e) => setDescription(e.target.value)}
//                   required
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//         )}

//       </div>

//       {/* ADD SCREENS SECTION */}
//       <div className="ques-paper-del" style={{ marginTop: "20px" }}>
//         <div className="personal-header">
//           <div className="header">
//             <label>ADD SCREENS</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleAccordionShareBranch}>
//             {isOpenShareBranch ? (
//               <div className="minus"></div>
//             ) : (
//               <div className="plus">+</div>
//             )}
//           </div>
//         </div>

//         {isOpenShareBranch && (
//           <div className="accordion-content">
//             <div
//               className="select-assign-test-container-ques-pap-del"
//               style={{ padding: "20px 0px 20px 0px" }}
//             >
//               <div className="grid-container-ques-paper-del">
//                 <div className="item1" style={{marginLeft: "20px"}}>
//                   <DropdownWithPagination
//                     label="Search Screen"
//                     width="100%"
//                     selected={selectedScreens}
//                     setSelected={setSelectedScreens}
//                     onSearchInputChange={fetchScreens}
//                     options={screenOptions}
//                     isRequired={true}
//                     showSelectAll={false}
//                     allowMultiple={true}
//                     itemsPerPage={4}
//                     placeholder="Type Screen Name..."
//                   />
//                 </div>
//                 <div style={{ gridColumn: "1 / -1", marginTop: 16 }}>
//                   <TableWithCrossSelections
//                     headers={headers}
//                     data={tableData}
//                     searchPlaceholder="Search screens..."
//                     selectedRows={selectedScreens}
//                     setSelectedRows={handleScreenTableRowSelection}
//                     renderQuestionText={(text) => text}
//                     renderQuestionTextModel={(text) => text}
//                     expandedStates={{}}
//                     toggleImage={() => {}}
//                     pageType="userEdit"
//                     onRowLinkClick={(row) => console.log("Row clicked:", row)}
//                     filterConfig={{}}
//                     handleDeleteRow={handleDeleteScreen}
//                     hideIdColumn={true}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* ADD REPORTS SECTION */}
//       <div className="ques-paper-del" style={{ marginTop: "20px" }}>
//         <div className="personal-header">
//           <div className="header">
//             <label>ADD REPORTS</label>
//           </div>
//           <div className="accordion-btn" onClick={() => setIsOpenReports((p) => !p)}>
//             {isOpenReports ? <div className="minus"></div> : <div className="plus">+</div>}
//           </div>
//         </div>

//         {isOpenReports && (
//           <div className="accordion-content">
//             <div
//               className="select-assign-test-container-ques-pap-del"
//               style={{ padding: "20px 0px 20px 0px" }}
//             >
//               <div className="grid-container-ques-paper-del">
//                 <div className="item1" style={{marginLeft: "20px"}}>
//                   <DropdownWithPagination
//                     label="Search Report"
//                     width="100%"
//                     selected={selectedReports}
//                     setSelected={setSelectedReports}
//                     onSearchInputChange={fetchReports}
//                     options={reportOptions}
//                     isRequired={true}
//                     showSelectAll={false}
//                     allowMultiple={true}
//                     itemsPerPage={4}
//                     placeholder="Type Report Name..."
//                   />
//                 </div>
//                 <div style={{ gridColumn: "1 / -1", marginTop: 16 }}>
//                   <TableWithCrossStudentGroup
//                     headers={reportHeaders}
//                     data={reportTableData}
//                     searchPlaceholder="Search reports..."
//                     selectedRows={selectedReports}
//                     setSelectedRows={handleReportTableRowSelection}
//                     renderQuestionText={(text) => text}
//                     renderQuestionTextModel={(text) => text}
//                     expandedStates={{}}
//                     toggleImage={() => {}}
//                     pageType="userEdit"
//                     onRowLinkClick={(row) => console.log("Report clicked:", row)}
//                     filterConfig={{}}
//                     handleDeleteRow={handleDeleteReport}
//                     hideIdColumn={true}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default NewCreateRole;

// 1st component
// import React, { useState, useRef, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
// import Dropdown from "../../../Components/Shared/Dropdown/Dropdown";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Informative.png";
// import { fetchRoleData } from "../../../Redux/features/CreateRole/createRoleSlice";
// import bin from "../../../Assets/Images/CreateRole/Trash.png";
// import search from "../../../Assets/Images/CreateRole/Search.png";
// import TableWithCrossStudentGroup from "../../StudentGrouph/TableWithCrossStudentGroup";
// import TableWithCrossSelections from "./TableWithCrossSelections";
// import DropdownWithPagination from "../../StudentGrouph/DropdownWithPagination";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import "./updatecreaterole.css";

// function NewCreateRole({
//   dataClient,
//   setMessageBox,
//   messageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
// }) {
//   const navigate = useNavigate();
//   const dropdownRef = useRef(null);
//   const [isOpenShareBranch, setIsOpenShareBranch] = useState(true);
//   const [roleName, setRoleName] = useState("");
//   const [roleCode, setRoleCode] = useState("");
//   const [status, setStatus] = useState(null);
//   const [description, setDescription] = useState("");
//   const [searchText, setSearchText] = useState("");
//   const [selectedScreens, setSelectedScreens] = useState([]);
//   const [searchResults, setSearchResults] = useState([]);
//   const [dropdownVisible, setDropdownVisible] = useState(false);
//   const [permissions, setPermissions] = useState({});
//   const [visibleSections, setVisibleSections] = useState({});

//   // --- Reports section states ---
//   const [isOpenReports, setIsOpenReports] = useState(true);
//   const [reportSearchText, setReportSearchText] = useState("");
//   const [reportSearchResults, setReportSearchResults] = useState([]);
//   const [selectedReports, setSelectedReports] = useState([]);
//   const [reportPermissions, setReportPermissions] = useState({});
//   const [reportDropdownVisible, setReportDropdownVisible] = useState(false);

//   const { data, loading, error } = useSelector((state) => state.createRole);
//   const dispatch = useDispatch();

//     useEffect(() => {
//       dispatch(fetchRoleData());
//     }, [dispatch]);

//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name;
//   const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id;
//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
//   const accessToken = localStorage.getItem("other");

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setDropdownVisible(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleSearch = () => {
//     if (searchText.trim().length > 0) {
//       const filtered = data.filter((item) =>
//         item.screen_name.toLowerCase().includes(searchText.toLowerCase())
//       );
//       setSearchResults(filtered);
//       setDropdownVisible(filtered.length > 0);
//     } else {
//       setDropdownVisible(false);
//       setSearchResults([]);
//     }
//   };

//   const handleSelectItem = (item) => {
//     if (!selectedScreens.some((screen) => screen.screen_id === item.screen_id)) {
//       setSelectedScreens([...selectedScreens, item]);
//     }
//     setDropdownVisible(false);
//     setSearchText("");
//   };

//   const toggleSectionVisibility = (screenId) => {
//     setVisibleSections((prev) => ({
//       ...prev,
//       [screenId]: !prev[screenId],
//     }));
//   };

//   const toggleAccordionShareBranch = () =>
//     setIsOpenShareBranch((prev) => !prev);

//   const handleSave = async () => {
//     if (!roleName || !roleCode || !description) {
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Please fill all required fields!</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//       return;
//     }

//   const role_screen_list = selectedScreens.flatMap((screen) => {
//     const perms = permissions[screen.screen_id] || {};

//     if (screen.sections && screen.sections.length > 0) {
//       return screen.sections.map((section) => ({
//         role_id: 0,
//         screen_id: screen.screen_id,
//         wb_scr_sec_id: section.sec_id, // ✅ send as wb_scr_sec_id (required by backend)
//         client_id: clientId,
//         create_perm: perms.create ? 1 : 0,
//         read_perm: perms.read ? 1 : 0,
//         update_perm:
//           perms.sections?.[section.sec_id]?.edit || perms.edit ? 1 : 0,
//         delete_perm: perms.delete ? 1 : 0,
//         create_date: new Date().toISOString(),
//         created_by: userName,
//         last_modified_by: userName,
//         last_modified_date: new Date().toISOString(),
//         print: perms.print ? 1 : 0,
//         download: perms.download ? 1 : 0,
//       }));
//     }

//     // If no sections
//     return {
//       role_id: 0,
//       screen_id: screen.screen_id,
//       wb_scr_sec_id: null,
//       client_id: clientId,
//       create_perm: perms.create ? 1 : 0,
//       read_perm: perms.read ? 1 : 0,
//       update_perm: perms.edit ? 1 : 0,
//       delete_perm: perms.delete ? 1 : 0,
//       create_date: new Date().toISOString(),
//       created_by: userName,
//       last_modified_by: userName,
//       last_modified_date: new Date().toISOString(),
//       print: perms.print ? 1 : 0,
//       download: perms.download ? 1 : 0,
//     };
//   });

//   const role_report_list = selectedReports.map((report) => {
//     const perms = reportPermissions[report.report_id] || {};
//     return {
//       role_id: 0, // ✅ make it integer
//       report_id: report.report_id,
//       client_id: clientId,
//       create_date: new Date().toISOString(),
//       created_by: userName,
//       last_modified_by: userName,
//       last_modified_date: new Date().toISOString(),
//       print: perms.print ? 1 : 0,
//       download: perms.download ? 1 : 0,
//     };
//   });

//     try {
//       const url = `${FULL_API_BASE_URL}/new-role-v2?client_id=${clientId}&role_code=${roleCode}&role_name=${roleName}&role_desc=${description}&user_name=${userName}&status=1&client_branch_id=${clientBranchId}`;

//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           accept: "application/json",
//           Authorization: `Bearer ${accessToken}`,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           role_screen_list,
//           role_report_list,
//         }),
//       });

//       const result = await response.json();

//       if (response.ok) {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{result.message || "Role created successfully!"}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(InterogativeImg);

//         // Optional: navigate back or clear form
//         setTimeout(() => navigate("/create_role_dashboard"), 1000);
//       } else {
//         throw new Error(result.message || "Failed to create role");
//       }
//     } catch (error) {
//       console.error("Error creating role:", error);
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{`Error: ${error.message}`}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//     }
//   };

//     const [expandedScreens, setExpandedScreens] = useState({});
//     const toggleExpand = (screenId) => {
//         setExpandedScreens((prev) => ({
//           ...prev,
//           [screenId]: !prev[screenId],
//         }));
//       };

//     const headers = [
//       "Screen Name",
//       "Edit",
//       "Create",
//       "Read",
//       "Delete",
//       "Print",
//       "Download",
//     ];

//     // 2. Updated tableData to fix expansion and auto-check/uncheck logic
//     const tableData = selectedScreens.map((screen) => {
//       const perms = permissions[screen.screen_id] || {};
//       const isExpanded = expandedScreens[screen.screen_id];
//       const sectionList = screen.sections || [];
//       const hasSections = sectionList.length > 0;

//       return [
//         // 1️⃣ Screen Name
//         screen.screen_name,

//         // 2️⃣ Edit Column with All Sections checkbox and expandable sections
//         <div style={{ display: "flex", flexDirection: "column" }}>
//           <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//             {/* All Sections Checkbox - only show if screen has sections */}
//             {hasSections && (
//               <>
//                 <input
//                   type="checkbox"
//                   className="cr-custom-checkbox"
//                   checked={perms.allSections || false}
//                   onChange={(e) => {
//                     const checked = e.target.checked;
//                     handlePermissionChange(screen.screen_id, null, "allSections", checked);

//                     // Don't auto-expand/collapse when checking/unchecking
//                     // Let user control expansion manually with +/- icon
//                   }}
//                 />

//                 {/* Expand/Collapse Icon - always clickable */}
//                 <span
//                   onClick={() => toggleExpand(screen.screen_id)}
//                   style={{
//                     cursor: "pointer",
//                     fontWeight: "bold",
//                     marginLeft: "8px",
//                     userSelect: "none",
//                   }}
//                 >
//                   {isExpanded ? "−" : "+"}
//                 </span>

//                 <span style={{ marginLeft: "8px", marginRight: "20px" }}>
//                   All Sections
//                 </span>
//               </>
//             )}

//             {/* If no sections, show single checkbox for edit permission */}
//             {!hasSections && (
//               <input
//                 type="checkbox"
//                 className="cr-custom-checkbox"
//                 checked={perms.edit || false}
//                 onChange={(e) =>
//                   handlePermissionChange(screen.screen_id, null, "edit", e.target.checked)
//                 }
//               />
//             )}
//           </div>

//           {/* Expandable sections list */}
//           {hasSections && isExpanded && (
//             <div
//               style={{
//                 marginTop: "10px",
//                 display: "flex",
//                 marginLeft: "24px",
//                 flexDirection: "column",
//                 gap: "10px",
//               }}
//             >
//               {sectionList.map((section) => {
//                 const secPerm = perms.sections?.[section.sec_id]?.edit || false;
//                 return (
//                   <label key={section.sec_id} style={{ display: "flex", gap: "6px" }}>
//                     <input
//                       type="checkbox"
//                       className="cr-custom-checkbox"
//                       checked={secPerm}
//                       onChange={(e) => {
//                         handlePermissionChange(
//                           screen.screen_id,
//                           section.sec_id,
//                           "edit",
//                           e.target.checked
//                         );
//                       }}
//                     />
//                     {section.sec_name}
//                   </label>
//                 );
//               })}
//             </div>
//           )}
//         </div>,

//         // 3️⃣ Create
//         <input
//           type="checkbox"
//           className="cr-custom-checkbox"
//           checked={perms.create || false}
//           onChange={(e) =>
//             handlePermissionChange(screen.screen_id, null, "create", e.target.checked)
//           }
//         />,

//         // 4️⃣ Read
//         <input
//           type="checkbox"
//           className="cr-custom-checkbox"
//           checked={perms.read || false}
//           onChange={(e) =>
//             handlePermissionChange(screen.screen_id, null, "read", e.target.checked)
//           }
//         />,

//         // 5️⃣ Delete
//         <input
//           type="checkbox"
//           className="cr-custom-checkbox"
//           checked={perms.delete || false}
//           onChange={(e) =>
//             handlePermissionChange(screen.screen_id, null, "delete", e.target.checked)
//           }
//         />,

//         // 6️⃣ Print
//         <input
//           type="checkbox"
//           className="cr-custom-checkbox"
//           checked={perms.print || false}
//           onChange={(e) =>
//             handlePermissionChange(screen.screen_id, null, "print", e.target.checked)
//           }
//         />,

//         // 7️⃣ Download
//         <input
//           type="checkbox"
//           className="cr-custom-checkbox"
//           checked={perms.download || false}
//           onChange={(e) =>
//             handlePermissionChange(screen.screen_id, null, "download", e.target.checked)
//           }
//         />,
//       ];
//     });

//     // 3. Updated handlePermissionChange to properly handle auto-check/uncheck
//     const handlePermissionChange = (screenId, secId, permissionType, checked) => {
//       setPermissions((prev) => {
//         const currentScreenPerms = prev[screenId] || {};
//         const currentSections = currentScreenPerms.sections || {};
//         const updatedSections = { ...currentSections };
//         const screen = selectedScreens.find(s => s.screen_id === screenId);
//         const sectionList = screen?.sections || [];

//         // Handle "All Sections" checkbox
//         if (permissionType === "allSections") {
//           const newSections = {};
//           sectionList.forEach(sec => {
//             newSections[sec.sec_id] = {
//               ...(updatedSections[sec.sec_id] || {}),
//               edit: checked,
//             };
//           });

//           return {
//             ...prev,
//             [screenId]: {
//               ...currentScreenPerms,
//               allSections: checked,
//               edit: checked,
//               sections: newSections,
//             },
//           };
//         }

//         // Handle individual section checkbox
//         if (secId) {
//           updatedSections[secId] = {
//             ...(updatedSections[secId] || {}),
//             edit: checked,
//           };

//           // Check if ALL sections are now checked (for auto-checking "All Sections")
//           const allChecked = sectionList.every(sec => updatedSections[sec.sec_id]?.edit);

//           // Check if ALL sections are now UNCHECKED (for auto-unchecking "All Sections")
//           const allUnchecked = sectionList.every(sec => !updatedSections[sec.sec_id]?.edit);

//           // Check if any section is checked (for edit permission)
//           const anyChecked = sectionList.some(sec => updatedSections[sec.sec_id]?.edit);

//           return {
//             ...prev,
//             [screenId]: {
//               ...currentScreenPerms,
//               // Only update "All Sections" if ALL are checked OR ALL are unchecked
//               allSections: allChecked ? true : (allUnchecked ? false : currentScreenPerms.allSections),
//               edit: anyChecked,
//               sections: updatedSections,
//             },
//           };
//         }

//         // Handle other permissions (create, read, delete, print, download)
//         const updatedScreenPerms = {
//           ...currentScreenPerms,
//           [permissionType]: checked,
//           sections: updatedSections,
//         };

//         // Auto-check download when print is checked
//         if (permissionType === "print" && checked) {
//           updatedScreenPerms.download = true;
//         }

//         return {
//           ...prev,
//           [screenId]: updatedScreenPerms,
//         };
//       });
//     };

//     // 4. Updated handleDeleteItem to also pass screen_id instead of screenId
//     const handleDeleteItem = (screenName) => {
//       // Find the screen by name to get its ID
//       const screenToDelete = selectedScreens.find(s => s.screen_name === screenName);
//       if (!screenToDelete) return;

//       setSelectedScreens(selectedScreens.filter((s) => s.screen_id !== screenToDelete.screen_id));
//       const updatedPermissions = { ...permissions };
//       delete updatedPermissions[screenToDelete.screen_id];
//       setPermissions(updatedPermissions);
//     };

//     const handleReportSearch = async () => {
//       if (reportSearchText.trim().length > 0) {
//         try {
//           const response = await fetch(
//             `${FULL_API_BASE_URL}/get-report-list-by-search-key?search_key=${reportSearchText}`,
//             {
//               method: "GET",
//               headers: {
//                 accept: "application/json",
//                 Authorization: `Bearer ${accessToken}`,
//               },
//             }
//           );
//           const result = await response.json();
//           if (result.status === 200 && result.data) {
//             setReportSearchResults(result.data);
//             setReportDropdownVisible(result.data.length > 0);
//           }
//         } catch (error) {
//           console.error("Error fetching reports:", error);
//         }
//       } else {
//         setReportDropdownVisible(false);
//         setReportSearchResults([]);
//       }
//     };

//     // === REPORT SELECTION HANDLER ===
//     const handleSelectReport = (report) => {
//       if (!selectedReports.some((r) => r.report_id === report.report_id)) {
//         setSelectedReports([...selectedReports, report]);
//       }
//       setReportDropdownVisible(false);
//       setReportSearchText("");
//     };

//     // === DELETE SELECTED REPORT ===
//     const handleDeleteReport = (reportId) => {
//       setSelectedReports(selectedReports.filter((r) => r.report_id !== reportId));
//       const updated = { ...reportPermissions };
//       delete updated[reportId];
//       setReportPermissions(updated);
//     };

//     // === PERMISSION CHANGE HANDLER (Print / Download only) ===
//     const handleReportPermissionChange = (reportId, type, checked) => {
//       setReportPermissions((prev) => ({
//         ...prev,
//         [reportId]: {
//           ...prev[reportId],
//           [type]: checked,
//         },
//       }));
//     };

//     const reportHeaders = ["Report ID", "Report Name", "Print", "Download"];

//     // Build tableData like the screen one
//     const reportTableData = selectedReports.map((report) => {
//       const perms = reportPermissions[report.report_id] || {};

//       return [
//         // 1️⃣ Report Name
//         report.report_id,
//         report.display_name,
//         // 2️⃣ Print Checkbox
//         <input
//           type="checkbox"
//           className="cr-custom-checkbox"
//           checked={perms.print || false}
//           onChange={(e) =>
//             handleReportPermissionChange(report.report_id, "print", e.target.checked)
//           }
//         />,

//         // 3️⃣ Download Checkbox
//         <input
//           type="checkbox"
//           className="cr-custom-checkbox"
//           checked={perms.download || false}
//           onChange={(e) =>
//             handleReportPermissionChange(report.report_id, "download", e.target.checked)
//           }
//         />,
//       ];
//     });

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">Create Role</span>
//         <div className="cr-header-btn-container">
//           <button
//             className="cr-cancel-btn"
//             onClick={() => navigate("/create_role_dashboard")}
//           >
//             CANCEL
//           </button>
//           <button className="cr-create-btn" onClick={handleSave}>
//             SAVE
//           </button>
//         </div>
//       </div>
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>Details</label>
//           </div>
//         </div>

//         <div className="accordion-content">
//           <div className="select-assign-test-container-ques-pap-del">
//             <div className="grid-container-ques-paper-del">
//               <div className="item1">
//                 <FormInputs
//                   label="Role Name"
//                   type="text"
//                   required
//                   value={roleName}
//                   onChange={(e) => setRoleName(e.target.value)}
//                 />
//               </div>

//               <div className="item2">
//                 <FormInputs
//                   label="Role Code"
//                   type="text"
//                   required
//                   value={roleCode}
//                   onChange={(e) => setRoleCode(e.target.value)}
//                 />
//               </div>

//               <div className="item4-creaete-role-description">
//                 <FormInputs
//                   label="Description"
//                   type="textarea"
//                   value={description}
//                   onChange={(e) => setDescription(e.target.value)}
//                   required
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* ======================== ADD SCREEN SECTION ======================== */}
//       <div className="ques-paper-del" style={{ marginTop: "20px" }}>
//         <div className="personal-header">
//           <div className="header">
//             <label>ADD SCREENS</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleAccordionShareBranch}>
//             {isOpenShareBranch ? (
//               <div className="minus"></div>
//             ) : (
//               <div className="plus">+</div>
//             )}
//           </div>
//         </div>

//         {isOpenShareBranch && (
//           <div
//             className="accordion-content"
//             style={{ padding: "20px 0px 20px 0px" }}
//           >
//             <div className="grid-container-ques-paper-del">
//               <div className="cr-screens-container">
//                 <div className="cr-screen-search-container">
//                   <input
//                     type="text"
//                     placeholder="Type here to search"
//                     value={searchText}
//                     onChange={(e) => setSearchText(e.target.value)}
//                     className="cr-add-screen-input"
//                     onFocus={() => handleSearch()}
//                   />
//                   <button
//                     className="cr-add-screen-button"
//                     onClick={handleSearch}
//                   >
//                     <img
//                       src={search}
//                       alt="search icon"
//                       style={{ width: "30px", height: "31px" }}
//                     />
//                   </button>
//                 </div>

//                 {dropdownVisible && (
//                   <ul
//                     className="cr-screen-dropdown"
//                     ref={dropdownRef}
//                     style={{ width: "100%", overflowY: "auto", marginLeft: "20px", color: "#6A6A6A" }}
//                   >
//                     {searchResults.map((item) => (
//                       <li
//                         key={item.screen_id}
//                         onClick={() => handleSelectItem(item)}
//                       >
//                         {item.screen_name}
//                       </li>
//                     ))}
//                   </ul>
//                 )}
//               </div>
//             </div>
//             {selectedScreens.length > 0 && (
//               <div>
//                 <TableWithCrossSelections
//                   headers={headers}
//                   data={tableData}
//                   searchPlaceholder="Search screens..."
//                   selectedRows={[]}
//                   setSelectedRows={() => {}}
//                   renderQuestionText={(text) => text}
//                   renderQuestionTextModel={(text) => text}
//                   expandedStates={{}}
//                   toggleImage={() => {}}
//                   pageType="userEdit"
//                   onRowLinkClick={(row) => console.log("Row clicked:", row)}
//                   filterConfig={{}}
//                   handleDeleteRow={(screenId) => handleDeleteItem(screenId)}
//                 />
//               </div>
//             )}
//           </div>
//         )}
//       </div>
//       {/* ======================== ADD REPORTS SECTION ======================== */}
//       <div className="ques-paper-del" style={{ marginTop: "20px" }}>
//         <div className="personal-header">
//           <div className="header">
//             <label>ADD REPORTS NAME</label>
//           </div>
//           <div className="accordion-btn" onClick={() => setIsOpenReports((p) => !p)}>
//             {isOpenReports ? <div className="minus"></div> : <div className="plus">+</div>}
//           </div>
//         </div>

//         {isOpenReports && (
//           <div className="accordion-content" style={{ padding: "20px 0px" }}>
//             {/* Report Search */}
//             <div className="grid-container-ques-paper-del">
//               <div className="cr-screens-container">
//                 <div className="cr-screen-search-container">
//                   <input
//                     type="text"
//                     placeholder="Search Report"
//                     value={reportSearchText}
//                     onChange={(e) => setReportSearchText(e.target.value)}
//                     className="cr-add-screen-input"
//                     onFocus={() => handleReportSearch()}
//                   />
//                   <button className="cr-add-screen-button" onClick={handleReportSearch}>
//                     <img
//                       src={search}
//                       alt="search icon"
//                       style={{ width: "30px", height: "31px" }}
//                     />
//                   </button>
//                 </div>

//                 {reportDropdownVisible && (
//                   <ul
//                     className="cr-screen-dropdown"
//                     ref={dropdownRef}
//                     style={{
//                       width: "100%",
//                       overflowY: "auto",
//                       marginLeft: "20px",
//                       color: "#6A6A6A",
//                     }}
//                   >
//                     {reportSearchResults.map((item) => (
//                       <li key={item.report_id} onClick={() => handleSelectReport(item)}>
//                         {item.display_name}
//                       </li>
//                     ))}
//                   </ul>
//                 )}
//               </div>
//             </div>

//             {/* Table using TableWithCrossStudentGroup */}
//             {selectedReports.length > 0 && (
//               <div style={{ marginTop: "20px" }}>
//                 <TableWithCrossStudentGroup
//                   headers={reportHeaders}
//                   data={reportTableData}
//                   searchPlaceholder="Search reports..."
//                   selectedRows={[]}
//                   setSelectedRows={() => {}}
//                   renderQuestionText={(text) => text}
//                   renderQuestionTextModel={(text) => text}
//                   expandedStates={{}}
//                   toggleImage={() => {}}
//                   pageType="userEdit"
//                   onRowLinkClick={(row) => console.log("Report clicked:", row)}
//                   filterConfig={{}}
//                   handleDeleteRow={(reportId) => handleDeleteReport(reportId)}
//                   hideIdColumn={true}
//                 />
//               </div>
//             )}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default NewCreateRole;

// Extract permissions from dataClient
// const userPermissions = dataClient?.client_schema_name?.[2]?.[0] || {};
// const canCreate = userPermissions.create_perm === 1;
// const canRead = userPermissions.read_perm === 1;
// const canEdit = userPermissions.edit_perm === 1;
// const canDelete = userPermissions.delete_perm === 1;
// const canPrint = userPermissions.print === 1;
// const canDownload = userPermissions.download === 1;

// // Check if user has minimum required permissions
// if (!canRead) {
//   return (
//     <div style={{ padding: '20px', textAlign: 'center' }}>
//       <h2>Access Denied</h2>
//       <p>You do not have permission to view this page.</p>
//     </div>
//   );
// }

{
  /* <input
  type="checkbox"
  disabled={!canCreate}
  checked={perms.create || false}
  onChange={(e) => {
    if (!canCreate) return;
    handlePermissionChange(screen.screen_id, null, "create", e.target.checked);
  }}
/> */
}

{
  /* <button
  onClick={handleSave}
  disabled={!canCreate}  // Disable if no create permission
  style={{
    backgroundColor: canCreate ? '' : '#d3d3d3',
    cursor: canCreate ? 'pointer' : 'not-allowed'
  }}
>
  SAVE
</button> */
}

{
  /* <NewCreateRole 
  sectionConfig={{
    details: { number: 1, title: "Details" },
    screens: { number: 2, title: "ADD SCREENS" },
    reports: { number: 3, title: "ADD REPORTS NAME" }
  }}
/> */
}
